import { Scenario } from '@qv-bid/entities';

export class ScenarioDependencyModalData {
  constructor(public currentScenario: Scenario, public scenarios: Scenario[]) {}
}
